<template>
  <div class="enroll-select">
    <div v-for="item in renderData" :key="item.uuid" class="select-item">
      <div
        class="content"
        @mousedown="() => selectItem(item)"
        v-html="item.name"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Watch, Component } from 'vue-property-decorator';
import { ISelectList } from '../../../billingSystem';
@Component({})
export default class SelectList extends Vue {
  @Prop({
    type: Array,
    default: () => [],
  })
  companyNameOptions!: [];

  @Prop({
    type: String,
    default: '',
  })
  highLightText!: '';

  @Prop({
    type: Boolean,
    default: false,
  })
  isHighLight!: boolean;

  renderData: ISelectList[] = [];

  @Watch('highLightText')
  highLightTextChange() {
    this.handleHighLight();
  }
  @Watch('companyNameOptions')
  companyNameOptionsChange() {
    this.handleHighLight();
  }

  selectItem({ id }: ISelectList) {
    const selectItem = this.companyNameOptions.find(
      (item: ISelectList) => id === item.id
    );
    this.$emit('change', selectItem);
  }

  handleHighLight() {
    // 判断数据是否为空
    if (!this.highLightText || !this.companyNameOptions.length) return;
    this.renderData = this.companyNameOptions.map((item: any) => {
      // 匹配关键字正则
      const replaceReg = new RegExp(this.highLightText, 'g');
      // 高亮替换v-html值
      const replaceString =
        '<span style="color: #6749ec;">' + this.highLightText + '</span>';
      const replaceName = item.name.replace(replaceReg, replaceString);

      return {
        ...item,
        name: replaceName,
      };
    });
  }

  mounted() {
    if (this.isHighLight) {
      this.handleHighLight();
    } else {
      this.renderData = this.companyNameOptions;
    }
  }
}
</script>

<style lang="scss" scoped>
.enroll-select {
  position: absolute;
  right: 0;
  z-index: 666;
  width: 538px;
  max-height: 318px;
  padding: 12px 0;
  overflow: auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 9px 18px 0px rgba(110, 104, 141, 0.3);
  .select-item {
    display: flex;
    flex-direction: column;
    padding: 12px 32px;
    color: #383333;
    font-size: 24px;
    .content {
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 33px;
    }
    .high-light {
      color: #6749ec;
    }
    .taxpayer-number {
      color: #ada9be;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 33px;
    }
    &:hover {
      background: #f4f4f4;
    }
    &:active {
      background: #f4f4f4;
    }
  }
}
</style>